import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import api, { setErrors } from '@/middlewares/api';
import PasswordField from '@/components/forms/password-field';
import { ROUTESLIST } from '@/static/urls';

class GuestChangePasswordFormComponent extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(data) {
    return new Promise((resolve, reject) => {
      let email = localStorage.getItem('user_email');

      try {
        const raw = localStorage.getItem('userInfo');
        if (raw) {
          const userInfo = JSON.parse(raw);
          if (userInfo && userInfo.email) {
            email = userInfo.email;
          }
        }
      } catch (_) {
        // ignore parse errors
      }

      if (!email) {
        return reject({ _error: 'Unable to verify your account. Please sign in again.' });
      }

      api
        .post('auth/verify-password', {
          email,
          password: data.current_password,
        })
        .then(() =>
          api.post('auth/change-password', {
            current_password: data.current_password,
            new_password: data.password,
            password_confirmation: data.password_confirmation,
          })
        )
        .then(() => {
          try {
            const raw = localStorage.getItem('userInfo');
            if (raw) {
              const userInfo = JSON.parse(raw);
              userInfo.isGuest = false;
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
            }
          } catch (_) {
            // ignore parse errors
          }
          toast.success('Password updated');
          this.props.history.push(ROUTESLIST.DASHBOARD_SAMPLES);
          return resolve(null);
        })
        .catch((err) => {
          if (!err.response) {
            return reject({ _error: 'Failed to update password.' });
          }
          if (err.response.status === 401) {
            return reject({ current_password: 'Current password is incorrect' });
          }
          if (err.response.status === 422) {
            return reject(setErrors(err.response));
          }
          return reject({ _error: 'Failed to update password. Please try again.' });
        });
    });
  }

  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    return (
      <form
        onSubmit={handleSubmit((data) => this.submitForm(data))}
        className="login-form signup-form"
        noValidate
      >
        <Field
          name="current_password"
          component={PasswordField}
          label="Current Password"
          className="signup-field"
        />
        <Field
          name="password"
          component={PasswordField}
          label="New Password"
          className="signup-field"
        />
        <Field
          name="password_confirmation"
          component={PasswordField}
          label="Confirm New Password"
          className="signup-field"
        />
        <div className="form-submit-row">
          <button
            className="btn btn-primary btn-fw"
            disabled={pristine || submitting}
            type="submit"
          >
            Update Password
          </button>
        </div>
      </form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.current_password) {
    errors.current_password = 'Current password is required';
  }
  if (!values.password) {
    errors.password = 'New password is required';
  } else if (values.password.length < 8) {
    errors.password = 'Password must be at least 8 characters long';
  }
  if (!values.password_confirmation) {
    errors.password_confirmation = 'Password confirmation is required';
  } else if (values.password !== values.password_confirmation) {
    errors.password_confirmation = 'Passwords do not match';
  }
  return errors;
};

export default reduxForm({
  form: 'guest-change-password-form',
  validate,
})(withRouter(GuestChangePasswordFormComponent));
